export default __webpack_public_path__ + "static/media/donut.ef714bb9.png";